import React from 'react';
import {
  Button,
  Message,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Table,
} from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { parseISO } from 'date-fns';
import { isEmpty } from 'lodash';
import { setLogModalShown, setLogPage } from 'state/bulkDeleteBusiness/actions';
import { formatLocalDateTime } from 'utils/dateTimeUtils';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import DefaultPagination from '../../components/DefaultPagination';

function LogModal() {
  const dispatch = useDispatch();
  const {
    shown,
    data,
    paging: { page, size, total },
    isLoading,
    errors,
  } = useSelector(state => state.bulkDeleteBusiness.log);

  const onPageChange = newPage => dispatch(setLogPage(newPage));
  const onClose = () => dispatch(setLogModalShown(false));

  return (
    <Modal open={shown} onClose={onClose}>
      <ModalHeader>Bulk Delete Business Logs</ModalHeader>
      <ModalContent>
        <Message negative hidden={isEmpty(errors)}>
          <Message.Header>Error</Message.Header>
          <ul>
            {errors.map(e => (
              <li>{e}</li>
            ))}
          </ul>
        </Message>
        <Table celled selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Time</Table.HeaderCell>
              <Table.HeaderCell>Logs</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {isLoading ? (
              <Table.Row>
                <Table.Cell colSpan={2}>
                  <LoadingSpinner />
                </Table.Cell>
              </Table.Row>
            ) : (
              data.map(log => (
                <Table.Row key={log.id}>
                  <Table.Cell>
                    {formatLocalDateTime(parseISO(log.time))}
                  </Table.Cell>
                  <Table.Cell>{log.log}</Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
        {!isLoading && (
          <DefaultPagination
            totalCount={total}
            activePage={page}
            pageSize={size}
            onPageChangeV2={onPageChange}
          />
        )}
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>Close</Button>
      </ModalActions>
    </Modal>
  );
}

export default LogModal;
